//jshint module : true
import page from '../actions/page';
import initData from 'init-data';

const getInitialCategoryId = () => {
    let id = 0;
    if (initData.categoryPath && initData.categoryPath.length > 0) {
        initData.categoryPath.forEach(item => {
            if (item.selected) {
                id = item.id;
            }
        });
    }
    return id;
};

const initialState = {
    type: initData.pageName || null,
    categoryPath: initData.categoryPath || [],
    allCategories: initData.allCategories || [],
    currentCategoryId: getInitialCategoryId(),
    metaTitle: '',
    metaDescription: '',
    metaRobots: '',
    canonicalLink: '',
    breadcrumbs: ''
};

export default (state = initialState, action) => {
    if (!action || !action.type) return state;
    switch (action.type) {
        case page.actionTypes.SET_PAGE_TYPE:
            return {
                ...state,
                type: action.payload
            };
        case page.actionTypes.SET_CATEGORY_PATH:
            return {
                ...state,
                categoryPath: action.payload,
                currentCategoryId: (action.payload && action.payload[0].id) || 0
            };
        case page.actionTypes.SET_CURRENT_CATEGORY_ID:
            return {
                ...state,
                currentCategoryId: action.payload
            };
        case page.actionTypes.SET_PAGE_META:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/reducers/page.js